import React, { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import LocationPng from "../assets/location tour search.svg";
import SearchPng from "../assets/toursImages/Vector-41.png";
import { CountryName } from '../pages/TourSearchPage';
import styles from '../components/backgroundTour.module.css';
import {X} from 'lucide-react';
import BASE_URL from '../config'; // Adjust the import path as necessary

const defaultImage = "https://via.placeholder.com/1920x1080"; 
const defaultBgColor = "#f0f0f0"; 

const BackgroundTour = () => {
  const [backgroundImage, setBackgroundImage] = useState(defaultImage);
  const [bgColor, setBgColor] = useState(defaultBgColor);
  const { country, setCountry } = useContext(CountryName);
  const [userInput, setUserInput] = useState('');
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const countryname = queryParams.get('country');
  const searchTerm = location.state?.searchTerm || '';

  useEffect(() => {
    if (country) {
      fetch(`${BASE_URL}/api/tour/search?query=${country}`)
        .then(response => response.json())
        .then(data => {
          setBackgroundImage(data.imageUrl || defaultImage);
          setBgColor(data.imageUrl ? "transparent" : defaultBgColor);
        })
        .catch(() => {
          setBackgroundImage(defaultImage);
          setBgColor(defaultBgColor);
        });
    } else {
      setBackgroundImage(defaultImage);
      setBgColor(defaultBgColor);
    }
  }, [country]);

  useEffect(() => {
    setCountry(countryname || searchTerm || '');
  }, [countryname, searchTerm]);

  return (
    <div 
      className={styles.backgroundContainer} 
      style={{ backgroundImage: `url(${backgroundImage})`, backgroundColor: bgColor }}
    >
      <div className={styles.overlay} />

      <div className={styles.contentContainer}>
        <div className={styles.textWrapper}>
          <h1 className={styles.title}>
            {country ? `${country} Packages` : "All Packages"}
          </h1>
          {country && (
            <p className={styles.description}>
              Explore {country}’s breathtaking landscapes, from snow-capped mountains to serene beaches. Enjoy thrilling adventures and rich culture.
            </p>
          )}
        </div>
      </div>

      {/* Search Bar */}
      <div className={styles.searchContainer}>
        <div className={styles.searchBox}>
          {/* Location Icon */}
          <div className={styles.locationWrapper}>
            <img src={LocationPng} alt='location' width={20} />
            <span>{country || "Country"}</span>
              {/* Reset Button (X) */}
              <button 
                className={styles.resetButton} 
                onClick={() => {
                  setCountry("");
                  setUserInput("");  // Clears the input field
                }}
              >
                  <X size={20} strokeWidth={2.5} />  
                </button>              
          </div>

          {/* Input Field */}
          <input
            style={{color: '#565656'}}
            type="text"
            placeholder="Search Preferred Country"
            value={userInput}
            className={styles.inputField}
            onChange={(e) => setUserInput(e.target.value)}
          />

          {/* Search Button */}
          <button className={styles.searchButton} onClick={() => setCountry(userInput)}>
            <img src={SearchPng} alt='search' width={20}/>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BackgroundTour;
